module.exports = __webpack_public_path__ + "modules-menu-background.png";